import axios from 'axios';
import config from '../config'
import { getJWTToken, getNewAuthToken, getOrgId } from '../utils/common';
import development from '../config/env/development';

let axiosInstance = axios.create({
    baseURL: config.api.baseUrl,
    headers: { 'Content-Type': 'application/json' }
})

const isHandlerEnabled = (config = {}) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? false : true
}

const requestHandler = (request) => {
    if (isHandlerEnabled(request)) {
        let token = getJWTToken();

        const urlObj = new URL(request.url);
        const pathParts = urlObj.pathname.split('/').filter(part => part);

        if (request.url.includes(config.api.scogoApiUrl) || request.url.includes(config.api.icebergApiUrl)) {

            // for local development
            // console.log('request.url:', request.url)
            // if (window.location.hostname === 'localhost' && request.url === 'https://api.development.scogo.in/preferences') {
            //     urlObj.protocol = 'http:';
            //     urlObj.host = 'localhost:3001';
            //     request.headers['x-scogo-id'] = 'user_2wcLMoytn9coLk0Xf1O5LGnI0L9';
            // }
            // for local development
            token = getNewAuthToken();
            urlObj.pathname = `/${config.api.version}/${pathParts.join('/')}`;
            request.url = urlObj.toString();
            const orgId = getOrgId();
            const isRoleApi = request.url === 'https://api.development.scogo.in/v1/admin/roles' || request.url === 'https://api.production.scogo.in/v1/admin/roles';
            if (orgId && !isRoleApi) request.headers['x-org-id'] = orgId;
        };
        request.headers['authorization'] = `Bearer ${token}`;
    }
    return request;
};


const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) {
        // Handle errors
    }
    return Promise.reject({ ...error })
}

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
        // Handle responses
    }
    return response
}

axiosInstance.interceptors.request.use(request => requestHandler(request))

axiosInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
)

export default axiosInstance;